import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { trackPixelEvent } from '../../lib/metaPixel';
export function Pricing() {
  return <section id="pricing" className="py-20 relative scroll-mt-20" data-id="element-189">
      <div className="container mx-auto px-4" data-id="element-190">
        <div className="text-center mb-16" data-id="element-191">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-192">
            ELEGÍ TU MEGAPACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-stretch" data-id="element-193">
          {/* Tier 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-slate-800/40 border border-white/10 flex flex-col h-full" data-id="element-194">
            <div className="mb-6" data-id="element-195">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-196">
                <span aria-hidden="true" data-id="element-197">😴</span> MEGAPACK BIOHACKING DEL SUEÑO
              </h3>
              <p className="text-amber-500 font-medium" data-id="element-198">6 Tomos + 6 Bonos</p>
            </div>

            <p className="text-slate-400 text-sm mb-8 flex-grow" data-id="element-199">
              <span className="font-semibold text-slate-300" data-id="element-200">Ideal para:</span>{' '}
              Cualquier persona que duerma mal, se despierte cansada o quiera
              optimizar su recuperación
            </p>

            <div className="mb-8" data-id="element-201">
              <div className="text-slate-500 line-through text-lg font-medium mb-1" data-id="element-202">
                $45.000
              </div>
              <div className="text-5xl font-display font-bold text-white flex items-baseline gap-2" data-id="element-203">
                $19.990{' '}
                <span className="text-xl text-slate-400 font-sans font-medium" data-id="element-204">
                  ARS
                </span>
              </div>
            </div>

            <Button size="lg" fullWidth variant="secondary" className="text-lg" href="https://www.recursoclosethegap.shop/cart/47826109726932:1" onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Megapack Biohacking del Sueño',
            value: 19990,
            currency: 'ARS'
          })} data-id="element-205">
              → QUIERO MI MEGAPACK AHORA
            </Button>
          </motion.div>

          {/* Tier 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="p-8 rounded-3xl bg-gradient-to-b from-amber-900/20 to-slate-900/80 border-2 border-amber-500/50 flex flex-col h-full relative shadow-[0_0_40px_rgba(245,185,66,0.1)]" data-id="element-206">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-slate-900 text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full flex items-center gap-1 shadow-lg" data-id="element-207">
              <span aria-hidden="true" data-id="element-208">⭐</span> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-209">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-210">
                <span aria-hidden="true" data-id="element-211">🚀</span> MEGAPACK + SISTEMA DE
                IMPLEMENTACIÓN AVANZADO
              </h3>
              <p className="text-amber-400 font-medium" data-id="element-212">
                6 Tomos + 6 Bonos + Acceso al Accelerator Premium
              </p>
            </div>

            <p className="text-slate-300 text-sm mb-8 flex-grow" data-id="element-213">
              <span className="font-semibold text-white" data-id="element-214">Ideal para:</span>{' '}
              Quienes quieren implementación personalizada, soporte directo y
              optimización del rendimiento diurno
            </p>

            <div className="mb-8" data-id="element-215">
              <div className="text-slate-500 line-through text-lg font-medium mb-1" data-id="element-216">
                $75.000
              </div>
              <div className="text-5xl font-display font-bold text-white flex items-baseline gap-2" data-id="element-217">
                $27.990{' '}
                <span className="text-xl text-slate-400 font-sans font-medium" data-id="element-218">
                  ARS
                </span>
              </div>
            </div>

            <Button size="lg" fullWidth className="text-lg shadow-xl" href="https://www.recursoclosethegap.shop/cart/48100982292692:1" onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Megapack + Sistema de Implementación Avanzado',
            value: 27990,
            currency: 'ARS'
          })} data-id="element-219">
              → QUIERO EL MEGAPACK + SISTEMA AVANZADO
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}